<template>
  <v-container>
    <v-card>
      <v-toolbar color="primary" dark flat>
        <v-toolbar-title>Link Stocks to Promotion</v-toolbar-title>
      </v-toolbar>

      <v-card-text>
        <v-form @submit.prevent="addItem">
          <v-autocomplete v-model="selectedPromotion" :items="promotionOptions" item-text="code" item-value="id"
            label="Select Promotion" outlined dense @change="onPromotionChange">
          </v-autocomplete>

          <v-autocomplete v-model="selectedStock" :items="stockOptions" item-text="product_name" item-value="id"
            label="Select Stock" outlined dense :disabled="!selectedPromotion">
            <template v-slot:selection="{ item }">
              {{ item.stock_code }}
            </template>
            <template v-slot:item="{ item }">
              {{ item.stock_code }} - {{ item.product_name }}
            </template>
          </v-autocomplete>

          <v-btn color="success" type="submit" :disabled="!selectedStock || !selectedPromotion">Add</v-btn>
        </v-form>
      </v-card-text>

      <v-divider />

      <v-card-text>
        <v-data-table :items="items" :headers="headers" dense>
          <template v-slot:item.actions="{ item }">
            <v-btn icon @click="remove(item.promotion_id, item.stock_id)">
              <v-icon color="error">mdi-delete</v-icon>
            </v-btn>
          </template>
          <template v-slot:item.stock_name="{ item }">
            <small>{{ item.stock_code }}</small> - {{ item.product_name }}
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import appAxios from '../../../../extra-functions/axios.extra'
import { mapState } from 'vuex'
import { ConfirmPopup, ErrorPopup, LoadingPopup, SuccessPopup } from '../../../../lib/utils'

export default {
  props: {
    promotionId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      selectedStock: null,
      selectedPromotion: null,
      items: [],
      promotionOptions: [],
      stockOptions: [],
      headers: [
        { text: 'Code', value: 'promotion_code' },
        { text: 'Promotion', value: 'promotion_name' },
        { text: 'Product', value: 'stock_name' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
    }
  },
  created() {
    this.fetchStocks()
    this.fetchPromotions()
    this.fetchLinkedStocks()
  },
  computed: {
    ...mapState({
      authToken: state => state.auth.token,
    }),
  },
  methods: {
    async fetchPromotions() {
      try {
        const { data } = await appAxios(this.authToken).get('/promotions')
        this.promotionOptions = data
      } catch (e) {
        console.error('Error fetching promotions:', e)
        ErrorPopup.fire('Error', 'Failed to fetch promotions')
      }
    },
    async fetchStocks() {
      try {
        const { data: { data: items } } = await appAxios(this.authToken).get('/stocks/get-by-store', { params: { noPromotion: true } })
        this.stockOptions = items
      } catch (e) {
        console.error('Error fetching stocks:', e)
        ErrorPopup.fire('Error', 'Failed to fetch stocks')
      }
    },
    async fetchLinkedStocks() {
      try {
        const { data: { data: items } } = await appAxios(this.authToken).get('/promotion-stocks')
        this.items = items
      } catch (e) {
        console.error('Error fetching linked stocks:', e)
        ErrorPopup.fire('Error', 'Failed to fetch linked stocks')
      }
    },
    async addItem() {
      try {
        if (!this.selectedStock || !this.selectedPromotion) return
        LoadingPopup.fire('Adding Stock', 'Please wait while we link the stock to the promotion...')
        await appAxios(this.authToken).post('/promotion-stocks', {
          promotion_id: this.selectedPromotion,
          stock_id: this.selectedStock,
        })
        this.stockOptions = this.stockOptions.filter(item => item.id !== this.selectedStock)
        this.selectedStock = null
        SuccessPopup.fire('Added', 'Stock successfully linked to promotion.')
        this.fetchLinkedStocks()
      } catch (e) {
        console.error('Add error:', e)
        ErrorPopup.fire('Error', 'Failed to add stock to promotion.')
      }
    },
    async remove(promotionId, stockId) {
      try {
        const { isConfirmed } = await ConfirmPopup.fire('Confirm Removal', 'Are you sure you want to unlink this stock from the promotion?')
        if (!isConfirmed) return
        await appAxios(this.authToken).delete(
          `/promotions/${promotionId}/stocks/${stockId}`,
        )
        this.fetchLinkedStocks()
        this.fetchStocks()
        SuccessPopup.fire('Removed', 'Stock unlinked from promotion.')
      } catch (e) {
        console.error('Delete error:', e)
        ErrorPopup.fire('Error', 'Failed to remove stock from promotion.')
      }
    },
  },
}
</script>